export const TEAM = [
    { name: 'Ava Lin', role: 'Co-founder and Chief Executive', image: '/images/team/ava-lin.jpg', wash: '#e2f37a', position: 'center 30%' },
    { name: 'Samuel Okoro', role: 'Co-founder, Head of Investments', image: '/images/team/samuel-okoro.jpg', wash: '#e8b65d', position: 'center 25%' },
    { name: 'Noah Bennett', role: 'CTO, platform and security', image: '/images/team/noah-bennett.jpg', wash: '#7fb8b0', position: 'center 25%' },
    { name: 'Isabel Ruiz', role: 'Head of Advice and Planning', image: '/images/team/isabel-ruiz.jpg', wash: '#d8a3a0', position: 'center 20%' },
    { name: 'Omar Haddad', role: 'Director of AI Research', image: '/images/team/omar-haddad.jpg', wash: '#a3a9f2', position: 'center 22%' },
    { name: 'Grace Holloway', role: 'Chief Risk and Trust Officer', image: '/images/team/grace-holloway.jpg', wash: '#a9c49a', position: 'center 22%' },
    { name: 'Lena Fischer', role: 'Design Director', image: '/images/team/lena-fischer.jpg', wash: '#c9d77a', position: 'center 30%' },
    { name: 'Kai Tanaka', role: 'Engineering Lead, Forecasts', image: '/images/team/kai-tanaka.jpg', wash: '#b7d39b', position: 'center 30%' }
]

export const STATS = [
    { value: 1.2, decimals: 1, prefix: '', suffix: 'M', label: 'Members' },
    { value: 38, decimals: 0, prefix: '$', suffix: 'B', label: 'In assets guided' },
    { value: 24, decimals: 0, prefix: '', suffix: '', label: 'Countries served' },
    { value: 4.9, decimals: 1, prefix: '', suffix: '', label: 'Member rating' }
]

export const VALUES = [
    { title: 'Clear beats clever', body: 'One honest next step will always matter more to us than a wall of clever charts.' },
    { title: 'Say it simply', body: 'When an answer needs a glossary to follow, it is not finished yet.' },
    { title: 'On your side only', body: 'Advisors on salary, zero commissions, and your data is never sold.' },
    { title: 'Think in decades', body: 'We judge our work by years of steady progress, never by a single day.' }
]
